import { openDialog } from '@component/dialog';
import wemeetClient from '@utils/wemeetClient';
import { captureException } from '@utils/sentry';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ISSUE_NAME from '@constant/issue-name';
import { useAppSelector } from '@store/hooks';
import { getMeetingInfoInput } from '@store/meeting/meeting.slice';
import { getSelfInfo } from '@store/user/user.slice';

export const useRtcBannedListener = () => {
  const { t } = useTranslation();

  const meetingInfoInput = useAppSelector(getMeetingInfoInput);
  const selfInfo = useAppSelector(getSelfInfo);
  useEffect(() => {
    const clientBanned = wemeetClient.onClientBanned((error) => {
      captureException(
        ISSUE_NAME.CLIENT_BANNED,
        JSON.stringify({ meetingCode: meetingInfoInput.meetingCode, userId: selfInfo?.id?.['@app_uid'] }),
        error,
      );
      openDialog({
        dialogId: 'trtcBanned',
        title: t('错误'),
        content: t('加入会议超时了。请尝试刷新页面后重新进会。'),
        onOk: () => {
          window.location.reload();
        },
      });
    });
    return () => {
      wemeetClient.removeListener(clientBanned);
    };
  }, []);
};
